import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from 'react-toastify';
import { FaUser, FaCalendarAlt, FaSave } from "react-icons/fa";
import '../styles/DutyRoster.css';

const SplitDutyRoster = () => {
     const token = sessionStorage.getItem("token") || localStorage.getItem("token");
     const BASE_URL = process.env.REACT_APP_BASE_URL;
     const [employees, setEmployees] = useState([]);
     const [selectedEmployee, setSelectedEmployee] = useState("");
     const [shiftslist, setShiftslist] = useState([]);
     const [selectedMonth, setSelectedMonth] = useState("");
     const [rosterData, setRosterData] = useState([]);
     const [employeeInputValue, setEmployeeInputValue] = useState("");
     const [isEditMode, setIsEditMode] = useState(false);
     const [employeeDetails, setEmployeeDetails] = useState(null);
     const [emp_type, setEmp_type] = useState("");

     const [doctorsSplitShifts, setDoctorsSplitShifts] = useState([]); // New state for doctors' split shifts

     useEffect(() => {
          fetchEmployees();
          fetchSplitShifts();
          fetchDoctorsSplitShifts(); // Fetch doctors' split shifts on component mount
     }, []);

     useEffect(() => {
          // If redirected from DutyRoster, pre-select the employee
          const saved = sessionStorage.getItem('split_selected_employee');
          if (saved) {
               try {
                    const emp = JSON.parse(saved);
                    setSelectedEmployee(emp.emp_id);
                    setEmployeeInputValue(`${emp.employee_code} - ${emp.employee_name}`);
                    setEmp_type(emp.emp_type || "");
                    // remove after consuming so it doesn't persist
                    sessionStorage.removeItem('split_selected_employee');
               } catch (err) {
                    console.error('Error parsing saved split employee:', err);
               }
          }
     }, []);

     const fetchEmployees = async () => {
          try {
               const response = await fetch(`${BASE_URL}/getEmployees`, {
                    method: "GET",
                    headers: {
                         "Content-Type": "application/json",
                         "Authorization": `Bearer ${token}`,
                    },
               });
               const result = await response.json();
               console.log("Employees API result:", result.data); // <-- Add this line
               // Filter only employees with split_shift = 'Y'
               const splitShiftEmployees = Array.isArray(result.data)
                    ? result.data.filter(emp => emp.split_shift === 'Y')
                    : [];
               setEmployees(splitShiftEmployees);
          } catch (error) {
               console.error("Error fetching employees:", error);
               toast.error("Failed to fetch employees");
          }
     };

     const fetchSplitShifts = async () => {
          try {
               const response = await fetch(`${BASE_URL}/getSplitShifts`, {
                    method: "GET",
                    headers: {
                         "Content-Type": "application/json",
                         "Authorization": `Bearer ${token}`,
                    },
               });
               const result = await response.json();
               setShiftslist(Array.isArray(result.data) ? result.data : []);
          } catch (error) {
               console.error("Error fetching shifts:", error);
               toast.error("Failed to fetch shifts");
          }
     };

     // fetch getDoctorsSplitShifts
     const fetchDoctorsSplitShifts = async () => {
          try {
               const response = await fetch(`${BASE_URL}/getDoctorsSplitShifts`, {
                    method: "GET",
                    headers: {
                         "Content-Type": "application/json",
                         "Authorization": `Bearer ${token}`,
                    },
               });
               const result = await response.json();
               setDoctorsSplitShifts(Array.isArray(result.data) ? result.data : []);
          } catch (error) {
               console.error("Error fetching doctors' split shifts:", error);
               toast.error("Failed to fetch doctors' split shifts");
          }
     };

     useEffect(() => {
          if (selectedMonth) {
               const [year, month] = selectedMonth.split("-");
               const firstDay = new Date(year, month - 1, 1);
               const startDayOfWeek = firstDay.getDay();
               const daysInMonth = new Date(year, month, 0).getDate();
               const daysArr = [];

               // Add empty placeholder days
               for (let i = 0; i < startDayOfWeek; i++) {
                    daysArr.push({
                         date: null,
                         shift_1_id: "",
                         shift_2_id: "",
                         weekoff: false,
                         isEmpty: true
                    });
               }

               // Add actual days
               for (let i = 1; i <= daysInMonth; i++) {
                    const dateStr = `${year}-${month.padStart(2, "0")}-${String(i).padStart(2, "0")}`;
                    daysArr.push({
                         date: dateStr,
                         shift_1_id: "",
                         shift_2_id: "",
                         weekoff: false,
                         isEmpty: false
                    });
               }
               setRosterData(daysArr);
          } else {
               setRosterData([]);
          }
     }, [selectedMonth]);

     useEffect(() => {
          const fetchSplitRoster = async () => {
               if (selectedEmployee && selectedMonth) {
                    try {
                         const response = await fetch(
                              `${BASE_URL}/getSplitDutyAttendance`,
                              {
                                   method: "POST",
                                   headers: {
                                        "Content-Type": "application/json",
                                        "Authorization": `Bearer ${token}`,
                                   },
                                   body: JSON.stringify({
                                        emp_id: selectedEmployee,
                                        selectedMonth: selectedMonth
                                   })
                              }
                         );
                         const result = await response.json();

                         if (
                              result.data &&
                              Array.isArray(result.data.roster) &&
                              result.data.roster.length > 0
                         ) {
                              setIsEditMode(true);
                              const mapped = result.data.roster.map(item => ({
                                   date: item.date,
                                   shift_1_id: item.shifts[0]?.shift_id || "",
                                   shift_2_id: item.shifts[1]?.shift_id || "",
                                   weekoff: !!item.is_weekoff,
                                   isEmpty: false // <-- ADD THIS
                              }));
                              setRosterData(mapped);
                         } else {
                              setIsEditMode(false);
                              const [year, month] = selectedMonth.split("-");
                              const firstDay = new Date(year, month - 1, 1);
                              const startDayOfWeek = firstDay.getDay();
                              const daysInMonth = new Date(year, month, 0).getDate();
                              const daysArr = [];

                              // Add empty placeholder days
                              for (let i = 0; i < startDayOfWeek; i++) {
                                   daysArr.push({
                                        date: null,
                                        shift_1_id: "",
                                        shift_2_id: "",
                                        weekoff: false,
                                        isEmpty: true
                                   });
                              }

                              // Add actual days
                              for (let i = 1; i <= daysInMonth; i++) {
                                   const dateStr = `${year}-${month.padStart(2, "0")}-${String(i).padStart(2, "0")}`;
                                   daysArr.push({
                                        date: dateStr,
                                        shift_1_id: "",
                                        shift_2_id: "",
                                        weekoff: false,
                                        isEmpty: false
                                   });
                              }
                              setRosterData(daysArr);
                         }
                    } catch (error) {
                         console.error("Error fetching split roster:", error);
                         toast.error("Failed to fetch roster data");
                    }
               }
          };
          fetchSplitRoster();
     }, [selectedEmployee, selectedMonth, BASE_URL, token]);

     const handleRosterChange = (idx, field, value) => {
          // Deep copy to ensure React state updates
          const updated = rosterData.map(row => ({ ...row }));

          // Find the index of the first actual day (not a placeholder)
          const firstActualDayIndex = updated.findIndex(row => !row.isEmpty);

          console.log("handleRosterChange idx:", idx, "field:", field, "value:", value, "firstActualDayIndex:", firstActualDayIndex);
          console.log("employeeDetails:", employeeDetails, "isEditMode:", isEditMode);

          // Auto-fill when changing the first actual day (regardless of edit mode)
          if (
               idx === firstActualDayIndex &&
               (field === "shift_1_id" || field === "shift_2_id")
          ) {
               // Auto-fill only the selected shift for all days (skip placeholders and weekoffs for Fixed_weekend)
               for (let i = firstActualDayIndex; i < updated.length; i++) {
                    if (!updated[i].isEmpty && (!employeeDetails?.week_off || !updated[i].weekoff)) {
                         updated[i][field] = value;
                    }
               }
               console.log("After auto-fill:", updated);
          } else {
               // Normal single-day change
               updated[idx][field] = value;
               console.log("Single change rosterData:", updated);
          }

          setRosterData(updated);
     };

     const handleEmployeeChange = (e) => {
          const value = e.target.value;
          const found = employees.find(emp =>
               `${emp.employee_code} - ${emp.employee_name}` === value
          );
          setSelectedEmployee(found ? found.emp_id : "");
          setEmployeeInputValue(value);
          // Set emp_type based on selected employee
          setEmp_type(found ? found.emp_type : "");
          // ensure employeeDetails is set so week_off etc is available
          setEmployeeDetails(found || null);
     };

     // const handleSubmit = async () => {
     //      // Validate that all non-weekoff days have both shifts selected
     //      const validRosterData = rosterData.filter(row => !row.isEmpty);
     //      const hasErrors = validRosterData.some(row => {
     //           if (!row.weekoff && (!row.shift_1_id || !row.shift_2_id)) {
     //                return true;
     //           }
     //           return false;
     //      });

     //      if (hasErrors) {
     //           toast.error("Please select both shifts for all working days");
     //           return;
     //      }

     //      const payload = {
     //           emp_id: selectedEmployee,
     //           month: selectedMonth,
     //           roster: validRosterData,
     //      };

     //      const loadingToast = toast.loading("Saving split duty roster...");
     //      try {
     //           const response = await fetch(`${BASE_URL}/createSplitDutyRoster`, {
     //                method: "POST",
     //                headers: {
     //                     "Content-Type": "application/json",
     //                     "Authorization": `Bearer ${token}`,
     //                },
     //                body: JSON.stringify(payload),
     //           });
     //           const result = await response.json();

     //           if (result.status) {
     //                toast.update(loadingToast, {
     //                     render: `Split duty roster ${isEditMode ? 'updated' : 'saved'} successfully!`,
     //                     type: 'success',
     //                     isLoading: false,
     //                     autoClose: 3000
     //                });

     //                setSelectedEmployee("");
     //                setSelectedMonth("");
     //                setEmployeeInputValue("");
     //                setRosterData([]);
     //                setEmployeeDetails(null);
     //                setIsEditMode(false);
     //           } else {
     //                toast.update(loadingToast, {
     //                     render: result.message || "Error saving roster",
     //                     type: 'error',
     //                     isLoading: false,
     //                     autoClose: 3000
     //                });
     //           }
     //      } catch (error) {
     //           console.error("Error saving roster:", error);
     //           toast.update(loadingToast, {
     //                render: "Error saving roster",
     //                type: 'error',
     //                isLoading: false,
     //                autoClose: 3000
     //           });
     //      }
     // };

     // Add this function inside your SplitDutyRoster component

     const handleSaveOrUpdateRoster = async () => {
          // Validate that all non-weekoff days have both shifts selected
          const validRosterData = rosterData.filter(row => !row.isEmpty);
          const hasErrors = validRosterData.some(row => {
               if (!row.weekoff && (!row.shift_1_id || !row.shift_2_id)) {
                    return true;
               }
               return false;
          });

          if (hasErrors) {
               toast.error("Please select both shifts for all working days");
               return;
          }

          const payload = {
               emp_id: selectedEmployee,
               selectedMonth: selectedMonth,
               roster: validRosterData,
          };

          const endpoint = isEditMode
               ? `${BASE_URL}/updateSplitDutyRoster`
               : `${BASE_URL}/createSplitDutyRoster`;

          const loadingToast = toast.loading(isEditMode ? "Updating..." : "Saving...");
          try {
               const response = await fetch(endpoint, {
                    method: "POST",
                    headers: {
                         "Content-Type": "application/json",
                         "Authorization": `Bearer ${token}`,
                    },
                    body: JSON.stringify(payload),
               });
               const result = await response.json();

               if (result.status) {
                    toast.update(loadingToast, {
                         render: `Split duty roster ${isEditMode ? 'updated' : 'saved'} successfully!`,
                         type: 'success',
                         isLoading: false,
                         autoClose: 3000
                    });

                    setSelectedEmployee("");
                    setSelectedMonth("");
                    setEmployeeInputValue("");
                    setRosterData([]);
                    setEmployeeDetails(null);
                    setIsEditMode(false);
               } else {
                    toast.update(loadingToast, {
                         render: result.message || "Error saving roster",
                         type: 'error',
                         isLoading: false,
                         autoClose: 3000
                    });
               }
          } catch (error) {
               console.error("Error saving roster:", error);
               toast.update(loadingToast, {
                    render: "Error saving roster",
                    type: 'error',
                    isLoading: false,
                    autoClose: 3000
               });
          }
     };

     const selectedEmployeeObj = employees.find(emp => emp.emp_id === selectedEmployee);
     const selectedEmployeeName = selectedEmployeeObj ? selectedEmployeeObj.employee_name : "";

     const availableShifts =
          emp_type === "DOCTOR"
               ? doctorsSplitShifts
               : shiftslist;

     return (
          <div className="duty-roster-wrapper">
               <ToastContainer position="top-right" />

               <div className="roster-header">
                    <h2>Split Duty Roster</h2>

               </div>

               <div className="roster-main-card">
                    {/* Filters */}
                    <div className="roster-filters-container">
                         <div className="filter-group employee-group">
                              <label>
                                   <FaUser /> Employee (Split Shift)
                              </label>
                              <input
                                   className="filter-input"
                                   type="text"
                                   placeholder="Select Employee"
                                   list="employees"
                                   value={employeeInputValue}
                                   onChange={handleEmployeeChange}
                                   autoComplete="off"
                              />
                              <datalist id="employees">
                                   {employees.map(emp => (
                                        <option
                                             key={emp.emp_id}
                                             value={`${emp.employee_code} - ${emp.employee_name}`}
                                        />
                                   ))}
                              </datalist>
                         </div>

                         <div className="filter-group month-group">
                              <label>
                                   <FaCalendarAlt /> Month
                              </label>
                              <input
                                   type="month"
                                   className="filter-input"
                                   min="2025-08"
                                   value={selectedMonth}
                                   onChange={e => setSelectedMonth(e.target.value)}
                                   disabled={!selectedEmployee}
                              />
                         </div>

                         {selectedEmployee && selectedMonth && (
                              <div className="filter-group action-group">
                                   <button className="save-btn" onClick={handleSaveOrUpdateRoster}>
                                        <FaSave /> {isEditMode ? 'Update' : 'Save'} Roster
                                   </button>
                              </div>
                         )}
                    </div>

                    {/* Roster Grid */}
                    {selectedEmployee && selectedMonth && rosterData.length > 0 ? (
                         <div className="roster-grid-container">
                              {rosterData.map((row, index) => {
                                   // Handle empty placeholder cells
                                   if (row.isEmpty) {
                                        return <div key={`empty-${index}`} className="roster-day-card empty-card"></div>;
                                   }

                                   const dateObj = new Date(row.date);
                                   const dd = String(dateObj.getDate()).padStart(2, "0");
                                   const dayName = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][dateObj.getDay()];
                                   const isWeekend = dateObj.getDay() === 0;

                                   return (
                                        <div
                                             key={row.date}
                                             className={`roster-day-card split-shift-card ${isWeekend ? 'weekend-card' : ''} ${row.weekoff ? 'weekoff-selected' : ''}`}
                                        >
                                             <div className="day-header">
                                                  <span className="date-number">{dd}</span>
                                                  <span className="day-name">{dayName}</span>
                                             </div>
                                             <div className="day-content split-content">
                                                  <div className="shift-group">
                                                       <label className="shift-label">Shift 1</label>
                                                       <select
                                                            className="shift-select"
                                                            value={row.shift_1_id}
                                                            onChange={e => handleRosterChange(index, "shift_1_id", e.target.value)}
                                                            disabled={row.weekoff}
                                                       >
                                                            <option value="">Select Shift 1</option>
                                                            {availableShifts.map(shift => (
                                                                 <option key={shift.id} value={shift.id}>
                                                                      {emp_type === "DOCTOR" ? shift.shift_name : shift.ShiftName}
                                                                 </option>
                                                            ))}
                                                       </select>
                                                  </div>

                                                  <div className="shift-group">
                                                       <label className="shift-label">Shift 2</label>
                                                       <select
                                                            className="shift-select"
                                                            value={row.shift_2_id}
                                                            onChange={e => handleRosterChange(index, "shift_2_id", e.target.value)}
                                                            disabled={row.weekoff}
                                                       >
                                                            <option value="">Select Shift 2</option>
                                                            {availableShifts.map(shift => (
                                                                 <option key={shift.id} value={shift.id}>
                                                                      {emp_type === "DOCTOR" ? shift.shift_name : shift.ShiftName}
                                                                 </option>
                                                            ))}
                                                            {!availableShifts.some(shift => shift.id === row.shift_2_id) && row.shift_2_id && (
                                                                 <option value={row.shift_2_id}>Invalid Shift (ID: {row.shift_2_id})</option>
                                                            )}
                                                       </select>
                                                  </div>

                                                  <label className="weekoff-checkbox">
                                                       <input
                                                            type="checkbox"
                                                            checked={row.weekoff}
                                                            onChange={() => {
                                                                 setRosterData(prev =>
                                                                      prev.map((item, idx) =>
                                                                           idx === index
                                                                                ? {
                                                                                     ...item,
                                                                                     weekoff: !item.weekoff,
                                                                                     shift_1_id: !item.weekoff ? "" : item.shift_1_id,
                                                                                     shift_2_id: !item.weekoff ? "" : item.shift_2_id
                                                                                }
                                                                                : item
                                                                      )
                                                                 );
                                                            }}
                                                       />
                                                       <span>Week Off</span>
                                                  </label>
                                             </div>
                                        </div>
                                   );
                              })}
                         </div>
                    ) : (
                         selectedEmployee && selectedMonth ? (
                              <div className="no-data-message">
                                   <p>No roster data available</p>
                              </div>
                         ) : (
                              <div className="no-data-message">
                                   <p>Please select employee and month to manage split duty roster</p>
                              </div>
                         )
                    )}
               </div>
          </div>
     );
};

export default SplitDutyRoster;